export const campaignsConfig = {
    homem: {
        id: 'clubdohomem',
        name: 'Promos Clube do Homem',
        primaryColor: '#27D46A',
        bgColor: 'black',

        // textos do layout
        topBarText: '🔥 Aproveite os melhores ACHADOS de 2025 🔥',
        title: 'TE AJUDO A ACHAR AS MELHORES PROMOÇÕES DA INTERNET',
        subtitle: 'Produtos com até 70% OFF, todos os dias no seu WhatsApp.',
        discountBadgeText: 'Produtos com 50 60 70% OFF',
        membersText: '+14.000 membros',
        freeText: '100% gratuito',
        spotsLabel: 'Pague mais barato!',
        spotsText: 'Restam 22 vagas',

        mainButtonText: 'ENTRAR NO GRUPO',
        whatsappLink: 'https://chat.whatsapp.com/SEU_LINK_AQUI',

        // caminhos das imagens (coloca na pasta public ou src/assets)
        heroImage: '/img/homem-hero.png',
        phoneImage: '/img/homem-phone.png',
    },
    mulher: {
        id: 'clubdasdivas',
        name: 'Promos Clube das Divas',
        primaryColor: '#27D46A',
        bgColor: 'black',

        // textos do layout
        topBarText: '🔥 Aproveite os melhores ACHADOS de 2025 🔥',
        title: 'TE AJUDO A ACHAR AS MELHORES PROMOÇÕES DA INTERNET',
        subtitle: 'Produtos com até 70% OFF, todos os dias no seu WhatsApp.',
        discountBadgeText: 'Produtos com 50 60 70% OFF',
        membersText: '+14.000 membros',
        freeText: '100% gratuito',
        spotsLabel: 'Pague mais barato!',
        spotsText: 'Restam 22 vagas',

        mainButtonText: 'ENTRAR NO GRUPO',
        whatsappLink: 'https://chat.whatsapp.com/SEU_LINK_AQUI',

        // caminhos das imagens (coloca na pasta public ou src/assets)
        heroImage: '/img/homem-hero.png',
        phoneImage: '/img/homem-phone.png',
    },
    promoblakout: {
        id: 'promoblackout',
        name: 'Promos Blackout',
        primaryColor: '#27D46A',
        bgColor: 'black',

        // textos do layout
        topBarText: '🔥 Aproveite os melhores ACHADOS de 2025 🔥',
        title: 'TE AJUDO A ACHAR AS MELHORES PROMOÇÕES DA INTERNET',
        subtitle: 'Produtos com até 70% OFF, todos os dias no seu WhatsApp.',
        discountBadgeText: 'Produtos com 50 60 70% OFF',
        membersText: '+14.000 membros',
        freeText: '100% gratuito',
        spotsLabel: 'Pague mais barato!',
        spotsText: 'Restam 22 vagas',

        mainButtonText: 'ENTRAR NO GRUPO',
        whatsappLink: 'https://chat.whatsapp.com/SEU_LINK_AQUI',

        // caminhos das imagens (coloca na pasta public ou src/assets)
        heroImage: '/img/homem-hero.png',
        phoneImage: '/img/homem-phone.png',
    },

    // mulher, outras empresas...
};
